import http from '../utils/http';
import sections from '../utils/sections';

export default {
  html: {
    drawer: null,
    header: null,
  },
  show: false,
  loading: false,

  toggle(e) {
    if (e) {
      e.preventDefault();
    }

    this.show = !this.show;
  },

  open() {
    this.show = true;
  },

  close() {
    this.show = false;
  },

  initCart(element) {
    if (!this.html.drawer) {
      this.html.drawer = element.innerHTML;
    }
  },

  initHeader(element) {
    if (!this.html.header) {
      this.html.header = element.innerHTML;
    }
  },

  async add(lineId, quantity) {
    this.loading = true;

    const response = await http.post(routes.cart_add_url, {
      items: [
        {
          id: lineId,
          quantity: quantity,
        },
      ],
      sections: ['header', 'cart-drawer'],
    });

    if (response && response.sections) {
      const headerHtml = sections.get(response, 'header', 'CartHeader');
      const drawerHtml = sections.get(response, 'cart-drawer', 'CartDrawer');

      if (headerHtml) {
        this.html.header = headerHtml;
      }

      if (drawerHtml) {
        this.html.drawer = drawerHtml;
      }
      
      this.open();
    }

    this.loading = false;
  },

  async get() {
    this.loading = true;

    const response = await http.get(routes.cart_url + '?section=cart-drawer');

    if (response && response.sections) {
      const drawerHtml = sections.get(response, 'cart-drawer', 'CartDrawer');

      if (drawerHtml) {
        this.html.drawer = drawerHtml;
      }
    }

    this.loading = false;
  },

  async remove(lineNumber) {
    this.loading = true;

    const response = await http.post(routes.cart_change_url, {
        line: lineNumber,
        quantity: 0,
        sections: ['cart-drawer', 'header']
    });

    if (response && response.sections) {
      const drawerHtml = sections.get(response, 'cart-drawer', 'CartDrawer');
      const headerHtml = sections.get(response, 'header', 'CartHeader');

      if (drawerHtml) {
        this.html.drawer = drawerHtml;
      }

      if (headerHtml) {
        this.html.header = headerHtml;
      }
    }

    this.loading = false;
  },

  async update(lineNumber, quantity) {
    this.loading = true;
    
    const response = await http.post(routes.cart_change_url, {
        line: lineNumber,
        quantity,
        sections: ['cart-drawer', 'header']
    });

    if (response && response.sections) {
      const drawerHtml = sections.get(response, 'cart-drawer', 'CartDrawer');
      const headerHtml = sections.get(response, 'header', 'CartHeader');

      if (drawerHtml) {
        this.html.drawer = drawerHtml;
      }

      if (headerHtml) {
        this.html.header = headerHtml;
      }
    }

    this.loading = false;
  }
};
